"use strict";
/**
 * Annotater is a way to log without immediately logging to the console or throwing an error
 * The primary reason for using this is ***in SDKs*** where you want to handle results differently
 *
 * For example:
 *    * In a backend environment, you want to use a logger to note when something doesn't pass validation and then fail the operation
 *    * In a frontend environment you want to display the errors to the user and allow them to correct the issue,
 *
 * This is a way to handle both of those scenarios with the same codebase
 *
 * Additionally if you want to try a bunch of things and then throw an error with all of the annotations, you can do that as well
 *
 * @example see checkFlexPayEligibilityAnnotated in src/flex-pay/index.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotatedError = exports.AnnotationType = exports.Annotater = void 0;
class Annotater {
    constructor() {
        this.overallResult = AnnotationType.Success;
        this.results = [];
        this.metadata = {};
    }
    /**
     * Override the metadata object
     * @param metadata the new metadata object to set
     */
    setMetadata(metadata) {
        this.metadata = metadata;
    }
    /**
     * Something was done successfully
     * @param message
     * @param extra
     */
    pass(message, extra) {
        this.results.push({ type: AnnotationType.Success, message, extra });
    }
    /**
     * Something happened but wasn't necessarily tied to a success or failure
     * @param message
     * @param extra
     */
    info(message, extra) {
        this.results.push({ type: AnnotationType.Note, message, extra });
    }
    /**
     * Something happened, but it's not necessarily a failure, but should probably be logged or watched
     * @param message
     * @param extra
     */
    warn(message, extra) {
        this.results.push({ type: AnnotationType.Warning, message, extra });
        if (this.overallResult !== AnnotationType.Failure) {
            this.overallResult = AnnotationType.Warning;
        }
    }
    /**
     * Something failed
     * @param message
     * @param extra
     */
    fail(message, extra) {
        this.results.push({ type: AnnotationType.Failure, message });
        this.overallResult = AnnotationType.Failure;
    }
    /**
     * Check if the overall result is a success
     * @returns true if the overall result is a success
     */
    succeeded() {
        return this.overallResult === AnnotationType.Success;
    }
    /**
     * A convenience method for throwing an error with the annotations
     * @param message
     */
    throw(message) {
        throw new AnnotatedError(message, this.results);
    }
}
exports.Annotater = Annotater;
var AnnotationType;
(function (AnnotationType) {
    AnnotationType["Success"] = "success";
    AnnotationType["Note"] = "note";
    AnnotationType["Warning"] = "warning";
    AnnotationType["Failure"] = "failure";
})(AnnotationType = exports.AnnotationType || (exports.AnnotationType = {}));
/**
 * An error with annotations
 *
 * You can check for it and get the results if it matches
 * @example
 * ```
 * try {
 *   someCodeThatThrowsAnAnnotatedError()
 * } catch (e){
 *  if (e instanceof AnnotatedError){
 *   // The annotations to use for logging / error messages
 *   console.log(e.annotations)
 *  }
 * }
 *
 * ```
 */
class AnnotatedError extends Error {
    constructor(message, annotations) {
        super(message);
        this.annotations = [];
        this.annotations = annotations;
    }
}
exports.AnnotatedError = AnnotatedError;
//# sourceMappingURL=index.js.map